export const PARTNER_POSTAMAT = 50;
export const PREPARED_TO_WITHDRAWAL_STATUS = 7;
export const OWN_PASTAMAT = 10;
export const HOURS_IN_DAY = 24;
